import { useState } from "react";
import { OrderModel } from "../../../models/order";
import { CartsModel } from "../../../models/carts";

interface Props {
  selectedData: OrderModel;
}

const calculateTotalQuantityInCarts = (carts: CartsModel[]): number => {
  let totalQuantity = 0;

  for (const cart of carts) {
    totalQuantity += cart.quantity;
  }

  return totalQuantity;
};

const usePackOrderController = ({ selectedData }: Props) => {
  const [carts, setCarts] = useState<CartsModel[]>([]);
  const [isReadyToShip, setIsReadyToShip] = useState<boolean>(false);

  // functions

  const handleCalculatePercentProgressBar = (): number => {
    const trueCount = calculateTotalQuantityInCarts(carts);
    const totalCount = calculateTotalQuantityInCarts(selectedData?.carts);
    const percentage = (trueCount / totalCount) * 100;
    return percentage;
  };

  function calculateTotalWithDeliveryFeeSum(): number {
    return carts.reduce(
      (sum, cart: CartsModel) => sum + cart?.quantity * cart?.productPrice,
      0
    );
  }

  const handlePickProduct = (getCarts: CartsModel, quantity: number) => {
    if (
      carts.filter((item) => item?.product?.id === getCarts?.product?.id)
        .length > 0
    ) {
      setCarts(
        carts?.map((item) => {
          if (item?.product?.id === getCarts?.product?.id) {
            return {
              ...getCarts,
              quantity,
            };
          } else {
            return item;
          }
        })
      );
    } else {
      setCarts([
        ...carts,
        {
          ...getCarts,
          quantity,
        },
      ]);
    }
  };

  const handlePlusProduct = (getCarts: CartsModel) => {
    if (
      carts.filter((item) => item?.product?.id === getCarts?.product?.id)
        .length > 0
    ) {
      if (
        getCarts?.quantity >
        carts.filter((item) => item?.product?.id === getCarts?.product?.id)[0]
          .quantity
      ) {
        handlePickProduct(
          getCarts,
          carts.filter((item) => item?.product?.id === getCarts?.product?.id)[0]
            .quantity + 1
        );
      }

    } else {
      handlePickProduct(getCarts, 1);
    }
  };

  const handleMinusProduct = (getCarts: CartsModel) => {
    if (
      carts.filter((item) => item?.product?.id === getCarts?.product?.id)
        .length > 0
    ) {
      handlePickProduct(
        getCarts,
        carts.filter((item) => item?.product?.id === getCarts?.product?.id)[0]
          .quantity - 1
      );
      if (
        carts.filter((item) => item?.product?.id === getCarts?.product?.id)[0]
          .quantity -
        1 <=
        0
      ) {
        setCarts(
          carts?.filter((item) => item?.product?.id !== getCarts?.product?.id)
        );
      }
    }
  };

  const handleCheckAddedAllProduct = (getCarts: CartsModel): boolean => {
    if (
      carts.filter((item) => item?.product?.id === getCarts?.product?.id)
        .length > 0
    ) {
      if (
        getCarts.quantity ===
        carts.filter((item) => item?.product?.id === getCarts?.product?.id)[0]
          .quantity
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const handleOpenIsReadyToShip = () => {
    setIsReadyToShip(true);
  };

  const handleCloseIsReadyToShip = () => {
    setIsReadyToShip(false);
  };

  // useEffect
  const isFinishedPacking: boolean =
    handleCalculatePercentProgressBar() === 100;

  const totalCurrentOrder = (): number => {
    let result: number = selectedData?.totoalWithDeliveryFee - (selectedData.totalNomalPrice - calculateTotalWithDeliveryFeeSum());
    return result;
    // return selectedData?.totoalWithDeliveryFee - (selectedData?.totalNomalPrice -(selectedData?.totalDiscountPrice ?? 0)-(selectedData?.totalDiscountPriceForCoupon ?? 0)-(selectedData?.totalDiscountPriceForPromotion ?? 0)- calculateTotalWithDeliveryFeeSum())
  }

  return {
    carts,
    handleCalculatePercentProgressBar,
    handlePickProduct,
    isReadyToShip,
    handleOpenIsReadyToShip,
    handleCloseIsReadyToShip,
    isFinishedPacking,
    handleCheckAddedAllProduct,
    handlePlusProduct,
    handleMinusProduct,
    calculateTotalWithDeliveryFeeSum,
    totalCurrentOrder
  };
};
export default usePackOrderController;
